import React from "react";

const VendorSelectionCountSummary = ({
  selectedCount = 0,
  internalCount = 0,
  marketplaceCount = 0,
  deletedCount,
  remainingSlots,
  showRemainingSlots = true,
  selectedLabel = "vendor/s selected",
  internalLabel = "internal",
  marketplaceLabel = "marketplace",
  deletedLabel = "vendor/s deleted ",
  remainingLabel = "slots remaining",
  className = "",
}) => (
  <div className={`flex flex-wrap items-center gap-5 ${className}`}>
    <div>
      <span className="text-2xl font-bold text-gray-950">{selectedCount}</span>
      <span className="ml-2 text-xs text-gray-500">{selectedLabel}</span>
    </div>
     {deletedCount !== undefined && (
      <>
        <div className="h-9 w-px bg-gray-200" />
        <div>
          <span className="text-xl font-bold text-red-600">{deletedCount}</span>
          <span className="ml-2 text-xs text-gray-500">{deletedLabel}</span>
        </div>
      </>
    )}
    <div className="h-9 w-px bg-gray-200" />
    <div>
      <span className="text-xl font-bold text-gray-950">{internalCount}</span>
      <span className="ml-2 text-xs text-gray-500">{internalLabel}</span>
    </div>
    <div className="h-9 w-px bg-gray-200" />
    <div>
      <span className="text-xl font-bold text-blue-700">{marketplaceCount}</span>
      <span className="ml-2 text-xs text-gray-500">{marketplaceLabel}</span>
    </div>
    {showRemainingSlots && (
      <>
        <div className="h-9 w-px bg-gray-200" />
        <div className="text-xs text-gray-500">{remainingSlots} {remainingLabel}</div>
      </>
    )}
  </div>
);

export default VendorSelectionCountSummary;
